import { useLayoutEffect, useState } from 'react';

const mediaQueries = {
  sm: '(max-width: 899px)',
  md: '(min-width: 900px) and (max-width: 1199px)',
  lg: '(min-width: 1200px)',
};

export const useBreakpoints = () => {
  const [breakpointsState, setBreakpointsState] = useState(() => {
    const initialState = {};
    for (const key in mediaQueries) {
      initialState[key] = window.matchMedia(mediaQueries[key]).matches;
    }
    return initialState;
  });

  useLayoutEffect(() => {
    const mediaQueryListeners = {};

    // Create media query listeners and update the state when they change
    for (const key in mediaQueries) {
      mediaQueryListeners[key] = window.matchMedia(mediaQueries[key]);
      const listener = (event) => {
        setBreakpointsState((prevState) => {
          return { ...prevState, [key]: event.matches };
        });
      };
      mediaQueryListeners[key].addListener(listener);
      listener(mediaQueryListeners[key]); // Initialize the state with the current matches
    }

    return () => {
      // Clean up the event listeners when the component unmounts
      for (const key in mediaQueries) {
        mediaQueryListeners[key].removeListener(mediaQueryListeners[key]);
      }
    };
  }, []);

  const breakpoints = (valueForSm, valueForMd, valueForLg) => {
    if (breakpointsState.lg) return valueForLg || valueForMd || valueForSm;
    if (breakpointsState.md) return valueForMd || valueForSm;
    return valueForSm;
  };

  return { ...breakpointsState, breakpoints };
};
